/**
 * =======================================
 * API Request for Access Routes
 * =======================================
 */
import Config from '@/config/app'
import api from '../index'

const {
  http
} = api

export default {
  baseUrl: Config.services.common.url,
  url: '/api/access-routes',
  http,

  /**
   * Get redshift_value
   * @params {Object}
   */
  searchByField (params) {
    const query = new URLSearchParams(params).toString()

    return this.http(this.baseUrl).get(`${this.url}/search-by-field?${query}`)
  }
}
